import React from "react";
import "../Footer/Footer.css";

const Footer = () => {
  return (
    <>
      <div className="footer__container">
        <div className="footer__inner-container">
          <h1>By RJD</h1>
        </div>
      </div>
    </>
  );
};

export default Footer;
